function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 1.714C14 .768 13.105 0 12 0s-2 .768-2 1.714V10H1.714C.768 10 0 10.895 0 12s.768 2 1.714 2H10v8.286c0 .947.895 1.714 2 1.714s2-.767 2-1.714V14h8.286c.947 0 1.714-.895 1.714-2s-.767-2-1.714-2H14V1.714z"
});

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgPlus;